import type { RootState } from '/business/shared/state/store';

export const hasAgreedToWelcomeSelector = (state: RootState) => state.basket?.meta?.started?.welcomeAgreed ?? false;

export const getReductionPlanVersionSelector = (state: RootState) => state.basket?.meta?.version?.reductionPlan ?? null;

export const getReduceCompletionVersionSelector = (state: RootState) => state.basket?.meta?.version?.reductionPlan ?? 2;

export const getConfirmedReductionPlanVersionSelector = (state: RootState) =>
  state.basket?.meta?.version?.reductionPlan ?? 3;

export const hasReducePageUnlockedSelector = (state: RootState) => state.basket?.meta?.reducePageUnlocked ?? false;

export const hasUndoLockSelector = (state: RootState) => state.basket?.meta?.hasUndoLock ?? false;

export const hasUndoCompleteEverRanOnReviewSelector = (state: RootState) =>
  state.basket?.meta?.hasUndoCompleteEverRanOnReview ?? false;

export const hasReductionStatementAgreedSelector = (state: RootState) =>
  state.basket?.meta?.commit?.statementAgreed ?? false;

export const hasReductionActivitiesSelectedSelector = (state: RootState) =>
  state.basket?.meta?.commit?.reductionActivities ?? false;

export const hasPrimaryFootprintCalculationAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signPrimary?.footprintCalculationAgreed ?? false;

export const hasPrimaryTermsAndConditionsAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signPrimary?.termsAndConditionsAgreed ?? false;

export const hasPrimaryCarbonNeutralProtocolAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signPrimary?.carbonNeutralProtocolAgreed ?? false;

export const getPrimarySignatureNameSelector = (state: RootState) =>
  state.basket?.meta?.signPrimary?.signatureName ?? '';

export const getPrimarySignatureDateSelector = (state: RootState) => state.basket?.meta?.signPrimary?.date ?? '';

export const hasSecondaryFootprintCalculationAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signSecondary?.footprintCalculationAgreed ?? false;

export const hasSecondaryTermsAndConditionsAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signSecondary?.termsAndConditionsAgreed ?? false;

export const getSecondarySignatureNameSelector = (state: RootState) =>
  state.basket?.meta?.signSecondary?.signatureName ?? '';

export const getSecondarySignatureDateSelector = (state: RootState) => state.basket?.meta?.signSecondary?.date ?? '';

export const hasOwnerFootprintCalculationAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signOwner?.footprintCalculationAgreed ?? false;

export const hasOwnerTermsAndConditionsAgreedSelector = (state: RootState) =>
  state.basket?.meta?.signOwner?.termsAndConditionsAgreed ?? false;

export const getOwnerSignatureNameSelector = (state: RootState) => state.basket?.meta?.signOwner?.signatureName ?? '';

export const getOwnerSignatureDateSelector = (state: RootState) => state.basket?.meta?.signOwner?.date ?? '';

export const hasRequestedOffsetOverrideSelector = (state: RootState) =>
  state.basket?.meta?.offset?.changeOffsetAmount ?? false;

export const getAspirationPercentageTargetSelector = (state: RootState) =>
  state.basket?.meta?.aspirationPercentageTarget ?? null;

export const hasAspirationTargetSavedSelector = (state: RootState) =>
  state.basket?.meta?.hasAspirationTargetSaved ?? false;

export const getTargetsBannerDismissedAtSelector = (state: RootState) =>
  state.basket?.meta?.targetsBannerDismissedAt ?? null;

export const hasInitiativeTipDismissedSelector = (state: RootState) =>
  state.basket?.meta?.hasInitiativeTipDismissed ?? false;
